import { stats } from 'instantsearch.js/es/widgets';
import { getInstance, registerWidget } from './searchsync-create-instance';
import { renderStatsTemplate as fallbackTemplate } from "../../stats-templates/count-template.js"
import { __, _n, sprintf } from './i18n.js';

function initStatsWidget() {
  const tgblAlgoliaDataJSON = window.atob(tgblSearchsyncDataEncoded);
  const tgblAlgoliaData = jQuery.parseJSON(tgblAlgoliaDataJSON);

  // TODO: Translations
  // const LOCALIZED = tgblAlgoliaFrontend.localized;

  // Get all elements with refinement list class
  // const elements = Array.from(document.getElementsByClassName("algolia-stats"));
  const elements = document.querySelectorAll("[data-filter-type='stats']")
  const elementsArray = Array.from(elements);
  
  // Group together refinement list elements that share an index
  const elementsGroupedByIndex = elementsArray.reduce((acc, element) => {
    const dataIndexValue = element.getAttribute("data-index");
    if (!acc[dataIndexValue]) {
      acc[dataIndexValue] = [];
    }
    acc[dataIndexValue].push(element);
    return acc;
  }, {});

  // Loop through each index
  for (const dataIndexValue in elementsGroupedByIndex) {
    if (elementsGroupedByIndex.hasOwnProperty(dataIndexValue)) {
      const elementsWithSameIndex = elementsGroupedByIndex[dataIndexValue];
      let search = getInstance(dataIndexValue);

      // Perform actions on elements with the same data-index value
      elementsWithSameIndex.forEach(async element => {
        let widgetID = element.getAttribute('data-id')
        let templatePath = tgblAlgoliaData[widgetID]['stats_template_path']
        let renderStatsTemplate = fallbackTemplate

        // The view's own words for what it lists ("Course" / "Courses"), so a count can read
        // "12 Courses". Normalised here rather than in each template: a widget saved before these
        // labels were wired through has no stats_labels key at all.
        const rawLabels = tgblAlgoliaData[widgetID]['stats_labels'] || {}
        const labels = {
          singular:     rawLabels.singular     || '',
          plural:       rawLabels.plural       || '',
          nothingFound: rawLabels.nothingFound || '',
        }

        // The widget's optional extras — the search query and the processing time — which are
        // toggles on the Meta Data tab rather than templates of their own. Normalised to booleans
        // for the same reason as the labels above: a widget saved before these existed has no
        // stats_options key, and a template reading options.showQuery should get false, not
        // undefined-from-undefined.
        const rawOptions = tgblAlgoliaData[widgetID]['stats_options'] || {}
        const options = {
          showQuery: !! rawOptions.showQuery,
          showTime:  !! rawOptions.showTime,
        }

        if ( templatePath ) {
          try {
            const module = await import( templatePath )
            renderStatsTemplate = module.default || module.renderStatsTemplate
          } catch ( error ) {
            console.error( `Error loading template from ${templatePath}:`, error )
          }
        } 

        let SearchsyncStats = ($, search, element) => {
          search.addWidgets([
            stats({
              container: element,
              templates: {
                // Inject i18n helpers alongside InstantSearch's own bindings (html, etc.)
                // so templates can translate UI chrome via __()/_n()/sprintf().
                text: (data, bindings) => renderStatsTemplate(data, { ...bindings, __, _n, sprintf, labels, options }),
              },
            })
          ]);
          registerWidget(element);
        };
        SearchsyncStats($, search, element);
      });
    }
  }
}

export { initStatsWidget }